function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
/**
 * Creates a function for generating the URL for fetching project entitlements.
 *
 * @param fields The fields to include in the response.
 * @param classification The project classification to include in the response.
 * @param limit The number of entitlements to return.
 * @returns A function for generating the URL for fetching project entitlements.
 * This function returns a list of entitlements for a given user.
 * @param pageIndex The page of entitlements to return.
 * @param previousPageData The data from the previous page.
 * @param search A string to search for in the entitlements.
 * @returns The entitlements for the user.
 */
export function factoryProjectEntitlementsKey(_ref) {
  let {
    path,
    fields,
    classification,
    limit
  } = _ref;
  return (pageIndex, previousPageData, search) => {
    var _previousPageData$pag;
    if (previousPageData && !previousPageData.results) {
      return null; // reached the end
    }
    if (pageIndex === 0) {
      return "".concat(getAdminApiUrl()).concat(path, "?") + new URLSearchParams(_objectSpread(_objectSpread({
        fields,
        'filter[classification]': classification
      }, search && {
        'filter[name]': search
      }), {}, {
        limit: limit.toString()
      })).toString();
    }
    return previousPageData === null || previousPageData === void 0 ? void 0 : (_previousPageData$pag = previousPageData.pagination) === null || _previousPageData$pag === void 0 ? void 0 : _previousPageData$pag.nextUrl;
  };
}
//# sourceMappingURL=factoryProjectEntitlementsKey.js.map